/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Card, CardBody, Row, Col} from "reactstrap";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

function ApList1(props) {

  let session = JSON.parse(window.sessionStorage.getItem('sessions'));

  const [p_aphorism, setPAhorism] = useState(null);

  const [aphorisms, setAphorisms] = useState([]);

  const [favoriteF, setFavoriteF] = useState(false);

  const selectF = (e, tmp, index) => {
    axios.get(URL_API+"setFavoiteAp", {
      params: {
        sel: session['id'], 
        id:tmp.id,
        p_id:props.p_id,
        v:(tmp.favor==1 ? 0 : 1),
        f:0
      }
    })
    .then(function (response) {    
      if(Array.isArray(response.data) && response.data.length > 0){
        setAphorisms(response.data);
      }
    });
  }
  
  useEffect(() => {    
    if(session === null){
      window.location = '/';
    }
    axios.get(URL_API+"getAphorismsAPI", {
      params: {
        sel: session['id'], 
        p_id:props.p_id,
        f:0
      }
    })
    .then(function (response) {
      // console.log(response.data, response.data != "");
      if(Array.isArray(response.data) && response.data.length > 0){
        setAphorisms(response.data);
      }
    });
  }, []);
  

  return (
    <>
      <div className="col-12 px-1 mt-2">
      {
        aphorisms?.map((tmp, index) =>
                 
        <div key={index} className="col-12 pt-2 pb-0 px-1 mb-3" style={{background:'rgb(244 244 244)', border:'1px solid rgb(245 244 244)'}}>                                         
          {
            tmp.word && (
              <div className="text-left a_word p-1">{tmp.word}</div>
            )
          }   
          {
            tmp.name && (
              <div className="text-left">{tmp.name}</div>
            )
          } 
          {
            tmp.man && (
              <div className="text-left">{tmp.man}</div>
            )
          }
          {
            tmp.content && (
              <div className="text-left">{tmp.content}</div>
            )
          }    
          {
            props.p_id > 0 && (
              <div className="text-right px-2">
                <i className={"fa fa-star pointer " + (tmp.favor ? 'sFavor' : 'uFavor')} onClick={(e) => selectF(e, tmp, index)} ></i>
              </div> 
            )
          }             
        </div>
            
      )}
      </div>
    </>
  );
}

export default ApList1;
